// extracted by mini-css-extract-plugin
export default {"warpper":"Layout_warpper__R36D6","divider":"Layout_divider__hlfQ0"};